// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__lAGwL","column":"style_column__2n0s4"};